var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-list-download"},_vm._l((_vm.fileList),function(item,index){return _c('span',{key:index,staticClass:"download",domProps:{"innerHTML":_vm._s(item.attachName)},on:{"click":function($event){_vm.$downloadFile(_vm.getAttachUrl(item))}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }